import React, {useCallback, useEffect, useMemo, useState} from "react"
import {useDataSourceMapping} from "./context"
import SettingsSearch from "../search"
import {EmptyView} from "@ciq/shared/components/views"
import {useDatasourceMappingSearch} from "./search"
import {Datasource, DatasourceModal} from "@ciq/shared/components/datasource_mapping"
import {ListView} from "@ciq/shared/components/list"

export function DatasourceMappingPane({show}) {
  const {search, actions: searchActions} = useDatasourceMappingSearch()
  const {isLoaded, datasets, hasDatasets, sources, hasSources, groups, claimedColumnIds, actions: mappingActions} = useDataSourceMapping()

  const [showModal, setShowModal] = useState({show: false, datasource: null})

  useEffect(() => {
    if (show || hasDatasets) return

    setShowModal(() => ({show: false, datasource: null}))
    mappingActions.reset()
    searchActions.reset()
  }, [mappingActions, hasDatasets, show, searchActions])

  useEffect(() => {
    if (!show || isLoaded) return
    mappingActions.getMappings()
  }, [isLoaded, mappingActions, show])

  const handleOnAdd = useCallback(() => {
    if (showModal.show) return
    setShowModal(() => ({show: true, datasource: null}))
  }, [showModal])

  const handleOnHide = useCallback(() => {
    if (!showModal.show) return
    setShowModal(() => ({show: false, datasource: null}))
  }, [showModal])

  const handleOnSave = useCallback((data) => {
    mappingActions.addMapping(data, () => {
      setShowModal(() => ({show: false, datasource: null}))
    })
  }, [mappingActions])

  const usedTableIds = useMemo(
    () => datasets.map(d => d.table?.id).filter(Boolean),
    [datasets]
  )

  if (!show) {
    return null
  }

  return (
    <div className="settings-users-list">
      <SettingsSearch
        search={search.term}
        onSearch={searchActions.set}
        buttonTitle="Add Source"
        buttonDisabled={!sources?.length}
        onAdd={handleOnAdd}
      />
      {!hasDatasets && <EmptyView>{!isLoaded ? "Loading..." : "No datasources found."}</EmptyView>}
      {hasDatasets && (
        <ListView>
          {datasets.map(dataset => (
            <Datasource
              key={dataset.id}
              dataset={dataset}
              groups={groups}
              sources={sources}
              claimedColumnIds={claimedColumnIds}
              actions={mappingActions}
              usedTableIds={usedTableIds}
            />
          ))}
        </ListView>
      )}
      {hasSources && isLoaded && (
        <DatasourceModal
          show={showModal.show}
          datasource={showModal.datasource}
          sources={sources}
          onHide={handleOnHide}
          onSave={handleOnSave}
        />
      )}
    </div>
  )
}
